module.exports = __webpack_public_path__ + "img/phone.541901eb.svg";